import objectAssign from 'object-assign';
import initialState from './initialState';
import { RECEIVE_STATEMENTS, RECEIVE_STATEMENT} from '../actions/actionTypes';

export default function statements(state = initialState.statements, action) {
  let newState;
  switch (action.type) {
    case RECEIVE_STATEMENTS:
      newState = objectAssign({}, state);
      newState.data = action.statements;
      return newState;
    case RECEIVE_STATEMENT:
      newState = objectAssign({}, state);
      newState.current = action.statement;
      return newState;
    default:
      return state;
  }
}
